import "./Background.css";

const Background = () => {
  return <div className="background__div"></div>;
};

export default Background;
